// Fachada do domínio Cards — métodos da instância (ver core.ts).
import { cardService } from './core';

export const markCardLost           = cardService.markCardLost;
export const listActiveCardsByLead  = cardService.listActiveCardsByLead;
export const listLostCardsByLead    = cardService.listLostCardsByLead;
export const reactivateCards        = cardService.reactivateCards;
export const deactivateCard         = cardService.deactivateCard;
export const deleteCard             = cardService.deleteCard;
export const countCardFinancials    = cardService.countCardFinancials;
export const assignActiveCardsOwner = cardService.assignActiveCardsOwner;
export const moveCardToStage        = cardService.moveCardToStage;
export const deactivateCardsByLead  = cardService.deactivateCardsByLead;
export const moveCardToPipeline     = cardService.moveCardToPipeline;
export const overwriteCardForMove   = cardService.overwriteCardForMove;

export type {
  MarkCardLostResult,
  CardActiveWithGraph,
  CardLostWithGraph,
  CardFinancialCount,
} from '@modules/cards';
